'use client';

import { useQuery } from '@apollo/client/react';

import { graphql } from '@/gql';

const HAS_GOVERNORHUB_KNOWLEDGE_QUERY = graphql(`
  query HasGovernorHubKnowledge {
    currentUser {
      _id
      hasGovernorHubKnowledge
    }
  }
`);

export const useHasGovernorHubKnowledge = () => {
  const { data, loading } = useQuery(HAS_GOVERNORHUB_KNOWLEDGE_QUERY, {
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
  });

  return {
    userId: data?.currentUser?._id,
    hasGovernorHubKnowledge: Boolean(
      data?.currentUser?.hasGovernorHubKnowledge,
    ),
    loading,
  };
};
